import type { FacebookAdAccount } from '@pages/audience/ui/AudienceDetail/AudienceDetailExport/ExportFacebookAds/utils'
import type { AudienceRuleUserExportFacebookAds } from '@shared/api/rtkQuery'

export const formatFacebookAdsExportList = (
  accountList: FacebookAdAccount[] = [],
  exportList: AudienceRuleUserExportFacebookAds[] = []
) => {
  const fbAdsList = accountList.map(({ id, name }) => {
    const exportStatus = exportList.find(data => data.accountId === id)

    return {
      accountId: id,
      accountName: name,
      ...exportStatus,
    }
  })

  return fbAdsList
}
